import React from 'react';
import { Button, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { TrackSelector as TrackSelectorIcon } from '@jbrowse/core/ui/Icons';
import { LoadingEllipses } from '@jbrowse/core/ui';
import { observer } from 'mobx-react';
import TrackContainer from './TrackContainer';
import TracksContainer from './TracksContainer';
import ImportForm from './ImportForm';
import GetSequenceDialog from './GetSequenceDialog';
import SearchResultsDialog from './SearchResultsDialog';
var useStyles = makeStyles()(function (theme) {
  return {
    note: {
      textAlign: 'center',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }
  };
});
var LinearGenomeView = observer(function (_ref) {
  var model = _ref.model;
  var tracks = model.tracks,
    error = model.error,
    initialized = model.initialized,
    hasDisplayedRegions = model.hasDisplayedRegions;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  if (!initialized && !error) {
    return React.createElement(LoadingEllipses, {
      variant: "h6"
    });
  }
  if (!hasDisplayedRegions || error) {
    return React.createElement(ImportForm, {
      model: model
    });
  }
  var MiniControlsComponent = model.MiniControlsComponent();
  var HeaderComponent = model.HeaderComponent();
  return React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, model.seqDialogDisplayed ? React.createElement(GetSequenceDialog, {
    model: model,
    handleClose: function handleClose() {
      return model.setGetSequenceDialogOpen(false);
    }
  }) : null, model.isSearchDialogDisplayed ? React.createElement(SearchResultsDialog, {
    model: model,
    handleClose: function handleClose() {
      return model.setSearchResults(undefined, undefined);
    }
  }) : null, React.createElement(HeaderComponent, {
    model: model
  }), React.createElement(MiniControlsComponent, {
    model: model
  }), React.createElement(TracksContainer, {
    model: model
  }, !tracks.length ? React.createElement(Paper, {
    variant: "outlined",
    className: classes.note
  }, !model.hideNoTracksActive ? React.createElement(React.Fragment, null, React.createElement(Typography, null, "No tracks active."), React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: model.activateTrackSelector,
    style: {
      zIndex: 1000
    },
    startIcon: React.createElement(TrackSelectorIcon, null)
  }, "Open track selector")) : React.createElement("div", {
    style: {
      height: '48px'
    }
  })) : tracks.map(function (track) {
    return React.createElement(TrackContainer, {
      key: track.id,
      model: model,
      track: track
    });
  })));
});
export default LinearGenomeView;